import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableContainer,
    TableRow,
    TableCell,
    Paper, Chip
} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt,
    faBuilding,
    faUser,
    faClock,
    faFile,
    faExclamationTriangle,
    faSearchLocation,
    faEyeSlash,
    faExclamationCircle,
    faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import "./СaseFilesDialog.css"

const CaseFileDialog = ({open, onClose, caseFile, users, caseFiles}) => {
    const [adminFile, setAdminFile] = useState(null);

    useEffect(() => {
        if (!caseFile) return
        const adminFile = caseFiles.find(file => file.parentId === caseFile.id)
        setAdminFile(adminFile)
    }, [caseFile, caseFiles])
    const findUserById = (userId) => {
        const user = users.find(user => user.id === userId)
        return `${user.firstName} ${user.lastName}`
    }


    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return 'თარიღი არ მოიძებნა';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return 'თარიღი არ მოიძებნა';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">

            {caseFile && (
                <DialogContent>
                    {caseFile.isSertificatFile ?
                        (<div className="official-document">ინსპექტირების სერტიფიკატი</div>) :
                        (<div className="official-document">ინსპექტირების ოქმი</div>)
                    }
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">

                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <FontAwesomeIcon icon={faFile}/>
                                    </TableCell>
                                    <TableCell>ფაილის სახელი:</TableCell>
                                    <TableCell>
                                        <a href={caseFile.path} target="_blank"
                                           rel="noopener noreferrer"
                                           className="lightblue-link-popup">
                                            {caseFile.name}
                                        </a>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        <FontAwesomeIcon icon={faUser}/>
                                    </TableCell>
                                    <TableCell>დოკუმენტი ატვირთა:</TableCell>
                                    <TableCell>{caseFile.fullname}</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        <FontAwesomeIcon icon={faClock}/>
                                    </TableCell>
                                    <TableCell>დოკუმენტი აიტვირთა:</TableCell>
                                    <TableCell>{formatDate(caseFile.createdAt)}</TableCell>
                                </TableRow>
                                {caseFile.isSertificatFile ? (
                                    <>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faCalendarAlt}/>
                                            </TableCell>
                                            <TableCell>გაცემის თარიღი:</TableCell>
                                            <TableCell>{formatDate(caseFile.sertificatReleaseDate)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faCalendarAlt}/>
                                            </TableCell>
                                            <TableCell>მოქმედების ვადა:</TableCell>
                                            <TableCell>{formatDate(caseFile.inspectionSertificatValidityPeriodDate)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faBuilding}/>
                                            </TableCell>
                                            <TableCell>გამცემი ორგანო:</TableCell>
                                            <TableCell>{caseFile.inspectionSertificatIssuingAgency}</TableCell>
                                        </TableRow>
                                    </>
                                ) : (
                                    <>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faCalendarAlt}/>
                                            </TableCell>
                                            <TableCell>განხორციელების თარიღი:</TableCell>
                                            <TableCell>{formatDate(caseFile.inspectionDocumentmplementation)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faCalendarAlt}/>
                                            </TableCell>
                                            <TableCell>გადამოწმების თარიღი:</TableCell>
                                            <TableCell>{formatDate(caseFile.inspectionDocumentCheckingDate)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faExclamationTriangle} style={{color: 'red'}}/>
                                            </TableCell>
                                            <TableCell>კრიტიკული შეუსაბამომებები:</TableCell>
                                            <TableCell>{caseFile.inconsistenciesCritical}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faExclamationCircle} style={{color: 'orange'}}/>
                                            </TableCell>
                                            <TableCell>არსებითი შეუსაბამომებები:</TableCell>
                                            <TableCell>{caseFile.inconsistenciesSubstantial}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'blue'}}/>
                                            </TableCell>
                                            <TableCell>არაარსებითი შეუსაბამომებები:</TableCell>
                                            <TableCell>{caseFile.inconsistenciesNonSubstantial}</TableCell>
                                        </TableRow>


                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faSearchLocation}/>
                                            </TableCell>
                                            <TableCell>ინსპექტირების ჩაუტარებლობა დარღვევა:</TableCell>
                                            <TableCell>{caseFile.violationFailureToConductInspection !== 0 ? "კი" : "არა"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faEyeSlash}/>
                                            </TableCell>
                                            <TableCell>ფარული ექსპლუატაცია დარღვევა:</TableCell>
                                            <TableCell>{caseFile.violationHiddenExploitation !== 0 ? "კი" : "არა"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faUser}/>
                                            </TableCell>
                                            <TableCell>ინსპექტორები:</TableCell>
                                            <TableCell>
                                                {caseFile.expertIdsWhoWorking && caseFile.expertIdsWhoWorking.length > 0 && (
                                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px'}}>
                                                        {caseFile.expertIdsWhoWorking.map((id, index) => (
                                                            <Chip key={index} label={findUserById(id)}
                                                                  variant="outlined"/>
                                                        ))}
                                                    </div>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    </>
                                )}


                            </TableBody>
                        </Table>
                    </TableContainer>

                    {adminFile && (
                        <>
                            <div className="official-document">ადმინისტრაციული სამართალდარღვევის ოქმი</div>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table">

                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faFile}/>
                                            </TableCell>
                                            <TableCell>ფაილის სახელი:</TableCell>
                                            <TableCell>
                                                <a href={adminFile.path} target="_blank"
                                                   rel="noopener noreferrer"
                                                   className="lightblue-link-popup">
                                                    {adminFile.name}
                                                </a>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faUser}/>
                                            </TableCell>
                                            <TableCell>დოკუმენტი ატვირთა:</TableCell>
                                            <TableCell>{adminFile.fullname}</TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faClock}/>
                                            </TableCell>
                                            <TableCell>დოკუმენტი აიტვირთა:</TableCell>
                                            <TableCell>{formatDate(adminFile.createdAt)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <FontAwesomeIcon icon={faClock}/>
                                            </TableCell>
                                            <TableCell>შედგენის თარიღი:</TableCell>
                                            <TableCell>{formatDate(adminFile.inpectOrderAttachmentDate)}</TableCell>
                                        </TableRow>


                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    )}
                </DialogContent>
            )}



            <DialogActions>
                <Button onClick={onClose} color="primary">
                    დახურვა
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CaseFileDialog;
